module.exports = __webpack_public_path__ + "static/media/Fox-News.7113de08.svg";